import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import classNames from 'classnames';
import t from 'tcomb-form';
import * as R from 'ramda';

require('react-datepicker/dist/react-datepicker.css');

export default class FormDatePicker extends Component {
    static displayName = 'FormDatePicker';

    constructor(props) {
        super(props);
        const {value, options} = props;
        this.state = {
            value: value ? moment(value) : null,
            minDate: options.minDate,
            maxDate: options.maxDate,
            disabled: options.disabled
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                value: moment(nextProps.value)
            });
        } else if (nextProps.options.flightEndDate) {
            this.setState({
                minDate: nextProps.options.minDate
            });
            this.handleChange(nextProps.options.flightEndDate);
        }
    }

    handleChange = value => {
        const {onChange, ctx} = this.props;
        this.setState({value}, () => {
            onChange(this.getValue(), ctx.path);
        });
    };

    toggleIsEditable = e => {
        e.preventDefault();
        const {disabled} = this.state;
        this.setState({
            disabled: !disabled
        });
    };

    getValue = () => (this.state.value ? this.state.value.toDate() : null);

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.getValue();
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    render() {
        const {options, ctx} = this.props;
        const {value, hasError} = this.state;
        const label = options.label || ctx.label;
        const labelNode = <label className="control-label">{label}</label>;
        const attrs = options.attrs || {};
        const datePickerOptions = R.pick(['disabled', 'minDate', 'maxDate'], this.state);

        return (
            <div
                {...attrs}
                className={classNames(
                    'form-group',
                    'form-datepicker',
                    attrs.className,
                    hasError && 'has-error'
                )}
            >
                {labelNode}
                {this.props.options.flightEndDate ? (
                    <a className="pull-right toggle" onClick={this.toggleIsEditable.bind(this)}>
                        Edit
                    </a>
                ) : null}
                <DatePicker
                    selected={value}
                    onChange={this.handleChange.bind(this)}
                    className="form-control"
                    popoverTargetAttachment="bottom center"
                    popoverAttachment="top center"
                    popoverTargetOffset="-10px 0px"
                    showYearDropdown
                    {...datePickerOptions}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_datepicker.js